export default __webpack_public_path__ + "static/media/Maestro.f1693fae.svg";